// Sample AI Service Domains
export const aiDomains = [
  { id: 1, domain: "openai.com", category: "LLM", description: "OpenAI API and ChatGPT" },
  { id: 2, domain: "claude.ai", category: "LLM", description: "Anthropic's Claude AI" },
  { id: 3, domain: "bard.google.com", category: "LLM", description: "Google Bard AI" },
  { id: 4, domain: "gemini.google.com", category: "LLM", description: "Google Gemini AI" },
  { id: 5, domain: "api.stability.ai", category: "Image Generation", description: "Stability AI API" },
  { id: 6, domain: "dall-e.openai.com", category: "Image Generation", description: "DALL-E image generation" },
  { id: 7, domain: "replicate.com", category: "Multi-modal", description: "Replicate AI API" },
  { id: 8, domain: "perplexity.ai", category: "Search", description: "Perplexity AI" },
  { id: 9, domain: "huggingface.co", category: "Model Repository", description: "Hugging Face" },
  { id: 10, domain: "bai-ai.com", category: "Code Generation", description: "BAI code assistant" },
];

// Sample DNS Logs
export const dnsLogs = [
  { id: 1, sourceIP: "192.168.1.105", timestamp: "2025-03-10T09:15:23", domain: "openai.com", queryType: "A", username: "jsmith", department: "Engineering" },
  { id: 2, sourceIP: "192.168.1.107", timestamp: "2025-03-10T09:17:45", domain: "claude.ai", queryType: "A", username: "mwilson", department: "Marketing" },
  { id: 3, sourceIP: "192.168.1.110", timestamp: "2025-03-10T09:32:12", domain: "gemini.google.com", queryType: "A", username: "tparker", department: "Product" },
  { id: 4, sourceIP: "192.168.1.115", timestamp: "2025-03-10T10:05:53", domain: "api.stability.ai", queryType: "A", username: "jdoe", department: "Design" },
  { id: 5, sourceIP: "192.168.1.120", timestamp: "2025-03-10T10:23:17", domain: "dall-e.openai.com", queryType: "A", username: "asmith", department: "Design" },
  { id: 6, sourceIP: "192.168.1.125", timestamp: "2025-03-10T10:45:09", domain: "huggingface.co", queryType: "A", username: "rjones", department: "Engineering" },
  { id: 7, sourceIP: "192.168.1.130", timestamp: "2025-03-10T11:02:31", domain: "bai-ai.com", queryType: "A", username: "mlee", department: "Engineering" },
  { id: 8, sourceIP: "192.168.1.135", timestamp: "2025-03-10T11:17:24", domain: "perplexity.ai", queryType: "A", username: "kwang", department: "Research" },
  { id: 9, sourceIP: "192.168.1.105", timestamp: "2025-03-10T11:34:56", domain: "openai.com", queryType: "A", username: "jsmith", department: "Engineering" },
  { id: 10, sourceIP: "192.168.1.107", timestamp: "2025-03-10T11:45:23", domain: "claude.ai", queryType: "A", username: "mwilson", department: "Marketing" },
  { id: 11, sourceIP: "192.168.1.140", timestamp: "2025-03-10T12:03:12", domain: "replicate.com", queryType: "A", username: "sjohnson", department: "Design" },
  { id: 12, sourceIP: "192.168.1.145", timestamp: "2025-03-10T12:17:45", domain: "huggingface.co", queryType: "A", username: "dnguyen", department: "Engineering" },
  { id: 13, sourceIP: "192.168.1.110", timestamp: "2025-03-10T12:32:18", domain: "gemini.google.com", queryType: "A", username: "tparker", department: "Product" },
  { id: 14, sourceIP: "192.168.1.115", timestamp: "2025-03-10T13:05:37", domain: "api.stability.ai", queryType: "A", username: "jdoe", department: "Design" },
  { id: 15, sourceIP: "192.168.1.150", timestamp: "2025-03-10T13:23:46", domain: "bard.google.com", queryType: "A", username: "jchen", department: "Product" },
  // Additional entries
  { id: 16, sourceIP: "192.168.1.105", timestamp: "2025-03-09T10:15:23", domain: "openai.com", queryType: "A", username: "jsmith", department: "Engineering" },
  { id: 17, sourceIP: "192.168.1.107", timestamp: "2025-03-09T14:17:45", domain: "claude.ai", queryType: "A", username: "mwilson", department: "Marketing" },
  { id: 18, sourceIP: "192.168.1.110", timestamp: "2025-03-09T16:32:12", domain: "gemini.google.com", queryType: "A", username: "tparker", department: "Product" },
  { id: 19, sourceIP: "192.168.1.115", timestamp: "2025-03-08T10:05:53", domain: "api.stability.ai", queryType: "A", username: "jdoe", department: "Design" },
  { id: 20, sourceIP: "192.168.1.120", timestamp: "2025-03-08T11:23:17", domain: "dall-e.openai.com", queryType: "A", username: "asmith", department: "Design" },
];

// Sample Usage Analytics
export const usageByDepartment = [
  { department: "Engineering", count: 6 },
  { department: "Marketing", count: 2 },
  { department: "Product", count: 3 },
  { department: "Design", count: 5 },
  { department: "Research", count: 1 },
];

export const usageByService = [
  { service: "OpenAI (ChatGPT)", count: 3 },
  { service: "Claude AI", count: 2 },
  { service: "Google AI (Gemini/Bard)", count: 3 },
  { service: "Stability AI", count: 2 },
  { service: "DALL-E", count: 1 },
  { service: "Hugging Face", count: 2 },
  { service: "BAI AI", count: 1 },
  { service: "Perplexity", count: 1 },
  { service: "Replicate", count: 1 },
];

export const dailyUsageTrend = [
  { date: "2025-03-01", count: 3 },
  { date: "2025-03-02", count: 5 },
  { date: "2025-03-03", count: 7 },
  { date: "2025-03-04", count: 4 },
  { date: "2025-03-05", count: 6 },
  { date: "2025-03-06", count: 8 },
  { date: "2025-03-07", count: 9 },
  { date: "2025-03-08", count: 12 },
  { date: "2025-03-09", count: 15 },
  { date: "2025-03-10", count: 20 },
];

// Sample Alerts
export const recentAlerts = [
  { id: 1, timestamp: "2025-03-10T09:15:23", type: "New AI Service", message: "First detection of BAI AI code assistant in your network", severity: "medium" },
  { id: 2, timestamp: "2025-03-09T14:32:45", type: "Unusual Usage Pattern", message: "Spike in AI service usage from Design Department", severity: "low" },
  { id: 3, timestamp: "2025-03-08T11:47:18", type: "New AI Service", message: "First detection of Perplexity AI in your network", severity: "medium" },
  { id: 4, timestamp: "2025-03-07T16:23:51", type: "Potential Data Sharing", message: "Large volume of queries to OpenAI from user jsmith", severity: "high" },
];

// Top Users
export const topUsers = [
  { username: "jsmith", department: "Engineering", services: ["OpenAI", "Hugging Face"], queryCount: 3 },
  { username: "tparker", department: "Product", services: ["Google Gemini"], queryCount: 2 },
  { username: "jdoe", department: "Design", services: ["Stability AI"], queryCount: 2 },
  { username: "mwilson", department: "Marketing", services: ["Claude AI"], queryCount: 2 },
  { username: "asmith", department: "Design", services: ["DALL-E"], queryCount: 1 },
];